import { observer } from "mobx-react-lite";
import React from "react";
import { modalNotificationsService } from "../../../services/notifications/ModalNotificationService";
import ErrorModal from "./ErrorModal";

export default observer(function ModalNotifications() {
  return (
    <div className="modal-container">
      {(modalNotificationsService.modalNotification.element ||
        modalNotificationsService.modalNotification.messageKey) && (
        <ErrorModal
          titleKey={modalNotificationsService.modalNotification.titleKey}
          messageKey={modalNotificationsService.modalNotification.messageKey}
          errorElement={modalNotificationsService.modalNotification.element}
          onClose={modalNotificationsService.closeModalNotification}
        />
      )}
    </div>
  );
});
